import { OrganizationAccessLevel } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/organization_access_pb";
import { OrgRoleIds } from "models/Role.model";

interface OrganizationAccessLike {
  organizationId?: string;
  accessLevel?: OrganizationAccessLevel;
  organization_id?: string;
  access_level?: OrganizationAccessLevel;
}

export function organizationAccessLevelToOrgRole(
  accessLevel: OrganizationAccessLevel,
): OrgRoleIds | undefined {
  switch (accessLevel) {
    case OrganizationAccessLevel.OWNER:
      return OrgRoleIds.Owner;
    case OrganizationAccessLevel.ADMIN:
      return OrgRoleIds.Admin;
    case OrganizationAccessLevel.MAINTAINER:
      return OrgRoleIds.Maintainer;
    case OrganizationAccessLevel.MEMBER:
      return OrgRoleIds.Member;
    default:
      return undefined;
  }
}

export function orgRoleToOrganizationAccessLevel(
  role: OrgRoleIds,
): OrganizationAccessLevel {
  switch (role) {
    case OrgRoleIds.Owner:
      return OrganizationAccessLevel.OWNER;
    case OrgRoleIds.Admin:
      return OrganizationAccessLevel.ADMIN;
    case OrgRoleIds.Maintainer:
      return OrganizationAccessLevel.MAINTAINER;
    case OrgRoleIds.Member:
    case OrgRoleIds.ViewOnly:
      return OrganizationAccessLevel.MEMBER;
  }
}

export function getOrganizationRoleForOrg(
  organizationAccesses: OrganizationAccessLike[] | undefined,
  organizationId: string,
): OrgRoleIds | undefined {
  const access = organizationAccesses?.find(
    (orgAccess) =>
      (orgAccess.organizationId ?? orgAccess.organization_id) ===
      organizationId,
  );
  if (!access) return undefined;

  return organizationAccessLevelToOrgRole(
    access.accessLevel ??
      access.access_level ??
      OrganizationAccessLevel.UNSPECIFIED,
  );
}
